var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "course-list section-holder container"
  }, [_c('div', {
    staticClass: "row pb-4 justify-content-end"
  }, [_c('h6', {
    staticClass: "col-md-6 text-left"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('course.course_description')))])]), _vm._v(" "), _c('h6', {
    staticClass: "col-md-6 text-right"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('download_syllabus')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-2 video-col"
  }, [_c('video', {
    staticClass: "video-css",
    attrs: {
      "poster": "../../static/assets/images/8.jpg"
    }
  }, [_c('source', {
    attrs: {
      "src": require("../../../static/assets/images/a.mp4"),
      "type": "video/mp4"
    }
  }), _vm._v("\r\n                    " + _vm._s(_vm.$t('common.errors.videoTagError')) + "\r\n                ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-2 video-col"
  }, [_c('video', {
    staticClass: "video-css",
    attrs: {
      "width": "100%",
      "height": "240",
      "poster": "../../static/assets/images/ref2.png"
    }
  }, [_c('source', {
    attrs: {
      "src": require("../../../static/assets/images/a.mp4"),
      "type": "video/mp4"
    }
  }), _vm._v("\r\n                     " + _vm._s(_vm.$t('common.errors.videoTagError')) + "\r\n                ")]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _vm._m(4)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "play-icon"
  }, [_c('i', {
    staticClass: "mdi mdi-play-circle"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-7 description"
  }, [_c('h5', [_vm._v("Topic1")]), _vm._v(" "), _c('p', [_vm._v("What is user going to learn in this topic, what are the take aways from this topic.\r\n                    A short note about the topic"), _c('br'), _vm._v("What is user going to learn in this topic, what are the take aways from this topic\r\n                    A short note about the topic\r\n                ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hr')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "play-icon"
  }, [_c('i', {
    staticClass: "mdi mdi-play-circle"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-7 description"
  }, [_c('h5', [_vm._v("Topic1")]), _vm._v(" "), _c('p', [_vm._v("What is user going to learn in this topic, what are the take aways from this topic.\r\n                    A short note about the topic"), _c('br'), _vm._v("What is user going to learn in this topic, what are the take aways from this topic\r\n                    A short note about the topic\r\n                ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-674c3c00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/course/courseList.vue
// module id = WE48
// module chunks = 1